import { IApplicationState, TBoardId } from '../../../types/types';

export const getBoardWorkHoursInDay = (
    state: IApplicationState,
    boardId: TBoardId
): number => {
    const board = state.model.dashboards[boardId];
    return board && board.workHoursInDay;
};
